import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Store} from '@ngrx/store';
import {map, switchMap, take} from 'rxjs/operators';
import {loadClusters, loadClustersFailure, loadClustersSuccess, selectClustersLoaded} from '../store/clusters';
import {Actions, ofType} from '@ngrx/effects';

export const requireClustersGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const store: Store = inject(Store);
  const actions$: Actions = inject(Actions);
  const router: Router = inject(Router);

  return store.select(selectClustersLoaded)
    .pipe(
      take(1),
      switchMap((loaded: boolean) => {
        if (loaded) {
          return of(true);
        }

        store.dispatch(loadClusters());

        // Wait for either success or failure at once.
        return actions$
          .pipe(
            ofType(loadClustersSuccess, loadClustersFailure),
            take(1),
            map((action): true | UrlTree => {
              const isSuccess: boolean = action.type === loadClustersSuccess.type;
              if (!isSuccess) {
                console.error('Failed to load clusters:', (action as ReturnType<typeof loadClustersFailure>).error);
                return router.parseUrl('/');
              }

              return true;
            })
          );
      })
    );
};
